/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of TestingByUrlH5EnvConfig
 */

import { IEnvConfigurationItemAsync } from 'com/didichuxing/tracker/config/IEnvConfigurationItemAsync';
import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import GlobalUtil from 'com/didichuxing/tracker/plugin/utils/GlobalUtil';

const OMG_DBG_KEY: string = '__OMG_DBG_v2';

/**
 * 端内H5环境配置
 *
 * @class
 * @implements {IEnvConfigurationItem}
 */
export default class TestingByScnshotH5EnvConfig implements IEnvConfigurationItemAsync {

    private context: ITrackerContext | undefined;

    /**
     * @override
     * @inheritDoc
     * @param {ITrackerContext} context
     * @returns {boolean}
     */
    public validate(context: ITrackerContext): boolean {
        this.context = context;
        return /[\?&]?omgdebug=true(&|$)/.test(location.href) || !!sessionStorage.getItem(OMG_DBG_KEY);
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITracker} tracker
     * @returns {Promise<void>}
     */
    public beforeDeliver(tracker: ITracker): Promise<void> {
        let omgId: string | undefined;
        if (/[?|&]oid=/.test(location.href)) {
            const searchItems: string[] = location.search.replace(/^\?/, '').split('&');
            for (let i: number = 0, j: number = searchItems.length; i < j; ++i) {
                if (searchItems[i].trim().indexOf('oid=') === 0) {
                    omgId = searchItems[i].split('=')[1].trim();
                    break;
                }
            }
            if (omgId) {
                Object.assign(this.context, { omgId: omgId });
                sessionStorage.setItem(OMG_DBG_KEY, omgId);
            }
        } else {
            omgId = sessionStorage.getItem(OMG_DBG_KEY) || '';
            Object.assign(this.context, { omgId: omgId });
        }
        return Promise.resolve();
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getPluginsUrl(): string {
        return GlobalUtil.getProtocol() + '{{cdnHost}}/static/{{cdnNamespace}}/{{version}}/omega.plugins.testing.scnshot.min.js';
    }
}
